export type CampaignRequestMessages = {
  campaignCreateError: string;
  campaignUpdateError: string;
  campaignCreateSuccess: string;
  campaignUpdateSuccess: string;

  // CONTACTS MESSAGES
  successRemoveContactMessage: string;
  errorRemoveContactMessage: string;

  // PRODUCTS MESSAGES
  productRemovedSuccess: string;
  productRemovedError: string;
};

export const CAMPAIGN_REQUEST_MESSAGES: CampaignRequestMessages = {
  campaignCreateSuccess: "Campanha criada com sucesso!",
  campaignUpdateSuccess: "Campanha atualizada com sucesso!",
  campaignCreateError: "Erro na criação da campanha!",
  campaignUpdateError: "Erro ao salvar a campanha!",

  // CONTACTS MESSAGES
  successRemoveContactMessage: "Contato removido com sucesso!",
  errorRemoveContactMessage: "Falha ao remover o contato.",

  // PRODUCTS MESSAGES
  productRemovedSuccess: "Produto removido com sucesso!",
  productRemovedError: "Houve um erro ao remover o produto.",
};
